import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=b20ec3b6&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=b20ec3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20ec3b6",
  null
  
)

export default component.exports